import { newE2EPage } from "@stencil/core/testing";

describe("ux-data-ingest", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-data-ingest></ux-data-ingest>`);
        const el = await page.find("ux-data-ingest");
        expect(el).toHaveClass("hydrated");
    });

    it("should pass the appropriate data to the ux-select component", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-data-ingest options="#options">
                <ux-select></ux-select>
                <script type="application/json" data-id="options">
                    [{ "name": "Option 1" }, { "name": "Option 2" }]
                </script>
            </ux-data-ingest>`);
        const uxSelect = await page.find("ux-select");
        await page.waitForChanges();
        const options = await uxSelect.findAll("option");
        expect(options.length).toBe(2);
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-data-ingest><div>child</div></ux-data-ingest>`
        );
        const el = await page.find("ux-data-ingest");
        expect(el).toMatchSnapshot();
    });
});
